module.exports = 'ttb.dashboard.page';

angular.module(module.exports, []).controller('DashboardController', require("./dashboard.controller"));


// WEBPACK FOOTER //
// ./components/dashboard-page/index.js